

export const separators = {
    AND: "AND",
    OR: "OR",
}

export const conditionType = {
   GROUP: 2,
   CONDITION: 1,
   QUERY: 3,
   SEPARATOR: 4
   
}

export const selectors = {
    NUMERIC: "NUMERIC",
    DROPDOWN: "DROPDOWN",
    TEXT: "TEXT",
    OPTIONS: "OPTIONS",
    CHECKBOX: "CHECKBOX"
}

export const operators = {
    AND: "AND",
    OR: "OR",

    EQUAL: "EQUAL",
    NOT_EQUAL: "NOT_EQUAL",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN: "LESS_THAN",
    LESS_THAN_OR_EQUAL_TO: "LESS_THAN_OR_EQUAL_TO",
    GREATER_THAN_OR_EQUAL_TO: "GREATER_THAN_OR_EQUAL_TO",
    BETWEEN: "BETWEEN",
    LIKE: "LIKE",
    ANY: "ANY",
    NOT: "NOT",
}

export const actions = {
    Show: "ShowElement",
    Require:"RequireElement",
    ReadOnly:"ReadOnlyElement",
    CustomError:"ShowCustomError",

}

export const eventOperators = {
    EQUAL:"=",
    NOT_EQUAL:"!=",
}

const fieldOperators = {
    EQUAL:"=",
    NOT_EQUAL:"!=",
    GREATER_THAN : ">",
    LESS_THAN: "<",
    LESS_THAN_OR_EQUAL_TO: "<=",
    GREATER_THAN_OR_EQUAL_TO: ">=",
    LIKE:"LIKE",
/*     BETWEEN:"BETWEEN", */
}

const questionOptionOperators = {
    EQUAL:"=",
    NOT_EQUAL:"!=",
    ANY:"ANY",
/*     NOT:"NOT", */
}

const questionTextOperators = {
    EQUAL:"=",
    NOT_EQUAL:"!=",
    GREATER_THAN : ">",
    LESS_THAN : "<",
    LESS_THAN_OR_EQUAL_TO: "<=",
    GREATER_THAN_OR_EQUAL_TO: ">=",
    LIKE:"LIKE",
  /*   BETWEEN:"BETWEEN", */
    
}
const conditionActionTypes = {
    CHECK_CONDITION_REQUEST: "CHECK_CONDITION_REQUEST",
    CHECK_CONDITION_SUCCESS: "CHECK_CONDITION_SUCCESS"
}
export const conditionConstants = {
    operators,
    actions,
    eventOperators,
    fieldOperators,
    questionOptionOperators,
    questionTextOperators,
    selectors,
    separators,
    actionTypes: conditionActionTypes
};